import { render, staticRenderFns } from "./IpsTextarea.vue?vue&type=template&id=2669ee9f&scoped=true"
import script from "./IpsTextarea.vue?vue&type=script&lang=js"
export * from "./IpsTextarea.vue?vue&type=script&lang=js"
import style0 from "./IpsTextarea.vue?vue&type=style&index=0&id=2669ee9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669ee9f",
  null
  
)

export default component.exports